import { Box } from 'src/components/Box';
import { Lightbox } from 'src/components/Lightbox';
import { Typography } from 'src/components/Typography';

interface ImageAttachmentProps {
  url: string; // thumbnail or small image
  fullSizeUrl?: string; // original image url
  filename?: string;
  onLoad?: () => void;
  maxWidth?: number;
  maxHeight?: number;
}

export const ImageAttachment: React.FC<ImageAttachmentProps> = ({
  url,
  fullSizeUrl,
  filename,
  onLoad,
  maxWidth = 500,
  maxHeight = 500,
}) => {
  return (
    <>
      <Lightbox
        imageUrl={fullSizeUrl || url}
        trigger={
          <Box
            component="img"
            src={url}
            onLoad={onLoad}
            sx={{
              borderRadius: 2,
              mt: 1,
              maxWidth: `${maxWidth}px`,
              maxHeight: `${maxHeight}px`,
              display: 'block',
              cursor: 'pointer',
            }}
          />
        }
      />
      {filename && (
        <Typography variant="caption" mt={0}>
          {filename}
        </Typography>
      )}
    </>
  );
};

export default ImageAttachment;
